<template>
 <v-container class="page-content px-5" style="  width: 100%">
   <v-toolbar
       class="removeBtnPaddingRight rounded-t-lg"
       color="#DADADA"
       flat
   >
     <v-text-field
         clearable
         single-line
         outlined
         dense
         v-model="search.value" label="Поиск" hide-details @keydown.enter="searchData" @click:clear="clearSearchData">
     </v-text-field>
     <v-spacer></v-spacer>
     <v-btn
         v-if="$vuetify.breakpoint.xsOnly"
         icon
         class="mr-0 dark-primary"
         @click="newUser"
     >
       <v-icon>add</v-icon>
     </v-btn>
     <v-toolbar-items  v-if="$vuetify.breakpoint.smAndUp">
       <v-btn
          text
           @click="newUser"
           class="rounded-tr-lg dark-primary"
       >
         Назначить пользователя
       </v-btn>
     </v-toolbar-items>
   </v-toolbar>
   <v-data-table
       :headers="headers"
       :items="items"
       :loading="isLoading"
       :page.sync="pagination.page"
       :items-per-page.sync="pagination.size"
       :server-items-length="count"
       :options.sync="options"
       multi-sort
       :footer-props="{'items-per-page-options':[10,50,100]}"
       class="elevation-1 rounded-b-lg"
   >
     <template v-slot:item.is_admin="{ item }">
       <v-icon
           :color="checkFlag(item.is_admin).color"
       >
         {{checkFlag(item.is_admin).icon}}
       </v-icon>
     </template>
     <template v-slot:item.is_entitled="{ item }">
       <v-icon
           :color="checkFlag(item.is_entitled).color"
       >
         {{checkFlag(item.is_entitled).icon}}
       </v-icon>
     </template>
     <template v-slot:item.is_representative="{ item }">
       <v-icon
           :color="checkFlag(item.is_representative).color"
       >
         {{checkFlag(item.is_representative).icon}}
       </v-icon>
     </template>
     <template v-slot:item.is_observer="{ item }">
       <v-icon
           :color="checkFlag(item.is_observer).color"
       >
         {{checkFlag(item.is_observer).icon}}
       </v-icon>
     </template>
     <template v-slot:item.actions="{ item }">
       <v-tooltip bottom>
         <template v-slot:activator="{ on, attrs }">
           <v-icon
             class="mr-2"
             @click="getLog(item)"
             v-bind="attrs"
             v-on="on"
           >
             assignment
           </v-icon>
         </template>
         <span>Журнал логирования</span>
       </v-tooltip>
       <v-tooltip bottom>
         <template v-slot:activator="{ on, attrs }">
           <v-icon
               class="mr-2"
               @click="editUser(item)"
               v-bind="attrs"
               v-on="on"
           >
             edit
           </v-icon>
         </template>
         <span>Редактировать пользователя</span>
       </v-tooltip>
       <v-tooltip bottom>
         <template v-slot:activator="{ on, attrs }">
           <v-icon
               @click="deleteUser(item)"
               v-bind="attrs"
               v-on="on"
           >
             delete
           </v-icon>
         </template>
         <span>Удалить пользователя</span>
       </v-tooltip>
     </template>
     <template v-slot:no-data>
       <v-btn
           color="primary"
           @click="updateData"
       >
         Обновить
       </v-btn>
     </template>
   </v-data-table>
   <RolesDialog
       v-if="dialog_add_edit"
       :opened="dialog_add_edit"
       :edit="edit_status"
       :user-data="user_data"
       @close="closeEditDialog"
   ></RolesDialog>
   <ApplyDialog
       v-if="dialog_delete"
       :opened="dialog_delete"
       :get-text="() => `Вы уверены, что хотите удалить данного пользователя ?`"
       @close="closeDeleteDialog"
   ></ApplyDialog>
 </v-container>
</template>


<script>

import {mapActions, mapGetters} from "vuex";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import TitledPageMixin from "@/mixins/TitledPageMixin";
import RolesDialog from "../components/RolesEditDialog";
import ApplyDialog from "@/modules/core/components/ApplyDialog";
import admin from "@/urls/roles/admin";
import names_core from "@/modules/core/routers/names";
import names from "@/modules/admin/routers/names";


export default {
  name: "AdminRolesList",
  components: {RolesDialog, ApplyDialog},
  mixins: [TitledPageMixin, PaginatedDataMapperMixin],
  data() {
    return {
      page_title: "Список ролей",
      dialog_add_edit: false,
      dialog_delete: false,
      user_data: undefined,
      edit_status: undefined,
      search: {
        parameter: "fio"
      },
      headers: [
        {text: "ФИО", value: "user", sortable: true, align: "start", width: "20%"},
        {text: "Организация", value: "organization", sortable: true, align: "start", width: "18%"},
        {text: "Подразделение", value: "department", sortable: true, align: "start", width: "20%"},
        { text: "Администратор", value: "is_admin", sortable: false, align: "center", width: "8%"},
        { text: "Согласующий", value: "is_entitled", sortable: false, align: "center", width: "8%"},
        { text: "Заявитель", value: "is_representative", sortable: false, align: "center", width: "8%"},
        { text: "Наблюдатель", value: "is_observer", sortable: false, align: "center", width: "8%"},
        { text: "Действия", value: "actions", sortable: false, align: "center", width: "20%"}
      ]
    }
  },
  watch: {
  },
  computed:{
    ...mapGetters({
      items: "admin/getRolesList",
      count: "admin/getRolesCount",
      isLoading: "admin/isLoadingRoles"
    })
  },
  methods: {
    ...mapActions({
      loadRolesList: "admin/loadRolesList",
      deleteRoles: "admin/deleteRoles"
    }),
    getLog(item) {
      this.$router.push({name: names.ROLES.LOG, params: {idRoles: item.id}}).catch(() => {})
    },
    updateData(){
      if (this.search.value) {
        this.search.value = ""
      }
      this.loadData()
    },
    loadData(url=undefined){
      this.loadRolesList({
        url: url,
        urlAppend: (url) => {
          let new_url = this.addPageParameter(this.addSizeParameter(url))
          if (this.search.value)
            new_url = this.addGetParameter(new_url, "fio", this.search.value)
          return new_url
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url);
        }
      })
    },
    newUser() {
      this.dialog_add_edit = true
      this.edit_status = false
      this.user_data = undefined
    },
    editUser(item) {
      this.dialog_add_edit = true
      this.edit_status = true
      this.user_data = item.id
    },
    deleteUser(item) {
      this.dialog_delete = true
      this.user_data = item
    },
    closeEditDialog(event) {
      this.loadData()
      this.dialog_add_edit = false
      this.user_data = undefined
    },
    closeDeleteDialog(event) {
      if(event){
        this.deleteRoles({
          id: this.user_data.id,
          finalizer: (val) => {
            this.loadData()
          },
          catcher:(val) => {
            this.mapErrors(val)
          }
        })
      }
      this.dialog_delete = false
      this.user_data = undefined
    },
    checkFlag(flag) {
      if (flag) return {icon: "check_circle", color: "green"}
      else return {icon: "radio_button_unchecked", color: "gray"}
    }
  },
  created() {
    if (admin.ADMIN.ALLOWED()){
      this.loadData()
    }
    else{
      this.$router.push({name: names_core.MAIN}).catch(() => {})
    }
  }

}

</script>

<style scoped>
.removeBtnPaddingRight>>>.v-toolbar__content{
  padding-right: 0px;
}
</style>
